import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { OfficeInterface } from "../../office.interface";
import { OFFICE_CONSTANT } from "../constant/office.constant";
import { PAGE_CONFIG } from "../../../common/constant/pageconfig.constant";

@Injectable({
  providedIn: "root",
})
export class OfficeService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };

  constructor(private httpClient: HttpClient) {}

  //soft delete
  public updateData(officeData: OfficeInterface) {
    let officeId = officeData.id;
    return this.httpClient.put(
      `${OFFICE_CONSTANT.OFFICE_SOFT_DELETE}/${officeId}`,
      officeData
    );
  }

  public getOfficeCount() {
    return this.httpClient.get(OFFICE_CONSTANT.OFFICE_COUNT);
  }

  public createOfficeData(officeData: OfficeInterface) {
    return this.httpClient.post(OFFICE_CONSTANT.OFFICE_DATA, officeData);
  }

  public getOfficeEdit(officeId: any) {
    return this.httpClient.get(`${OFFICE_CONSTANT.OFFICE_DATA}/${officeId}`);
  }

  public updateOfficeData(officeData: OfficeInterface) {
    let officeId = officeData.id;
    return this.httpClient.put(
      `${OFFICE_CONSTANT.OFFICE_DATA}/${officeId}`,
      officeData
    );
  }

  public getOfficeDashboardData() {
    return this.httpClient.get(OFFICE_CONSTANT.SUPER_DASHBOARD_DATA);
  }

  public deleteOfficeData(officeId: any) {
    return this.httpClient.delete(`${OFFICE_CONSTANT.OFFICE_DATA}/${officeId}`);
  }

  public getCast() {
    return this.httpClient.get(`${OFFICE_CONSTANT.CAST}`);
  }

  public userCheck(obj) {
    return this.httpClient.post(`${OFFICE_CONSTANT.USER_CHECK}`, obj);
  }

  public getPageConfig() {
    return this.httpClient.get(PAGE_CONFIG.Office_page);
  }
}
